import React from 'react';
import { Button, FormInstance } from 'antd';

interface SubmitButtonProps {
  form: FormInstance;
  loading?: boolean;
  isDisabled?: boolean;
}

const SubmitButton: React.FC<React.PropsWithChildren<SubmitButtonProps>> = ({
  form,
  children,
  loading,
  isDisabled = false,
}) => {
  const handleSubmit = () => {
    form.submit();
  };

  return (
    <Button
      type={'primary'}
      htmlType="submit"
      loading={loading}
      onClick={handleSubmit}
      disabled={isDisabled}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
